import React, { useMemo } from "react";
import { useSuspense, NetworkErrorBoundary } from "@rest-hooks/react";
import { useParams } from "react-router-dom";

import MerchCollectionResource from "resources/checkin/MerchCollectionResource";
import EventResource from "resources/checkin/EventResource";

import MerchCollectionsList from "components/MerchCollectionsList";
import PageTop from "components/PageTop";

import NetworkError from "../Tickets/NetworkError";

const MerchCollectionsContent = () => {
  const { eventUuid } = useParams();

  // Collection is event-level (not session-scoped) — no session_id in params.
  const requestParams = useMemo(() => ({ event_uuid: eventUuid }), [eventUuid]);

  const event = useSuspense(EventResource.detail(), { id: eventUuid });

  const pageInfo = useMemo(
    () => ({
      name: event?.title ? `${event.title} — Merch` : "Merch collection",
      description: "Collect purchased merch at the store",
    }),
    [event]
  );

  return (
    <main>
      <div className="content">
        <PageTop pageInfo={pageInfo} />
        <MerchCollectionsList Resource={MerchCollectionResource} resourceParams={requestParams} />
      </div>
    </main>
  );
};

const MerchCollections = () => {
  return (
    <NetworkErrorBoundary fallbackComponent={NetworkError}>
      <MerchCollectionsContent />
    </NetworkErrorBoundary>
  );
};

export default MerchCollections;
